
/* injects from baggage-loader */

angular.module("siter.io").controller("NewLessonTemplateController", [
  "$scope", "$rootScope", "$modalInstance", "Lesson", "Translit", "FileUploader", "Restangular", "$state", "$cookies",
  ($scope, $rootScope, $modalInstance, Lesson, Translit, FileUploader, Restangular, $state, $cookies) => {
    $scope.landing = {};

    $scope.transliterate = (text, entorus) => {
      if (entorus === null) {
        entorus = false;
      }

      Translit.one(text, entorus);
    };

    $scope.transliterate_3 = (text, entorus) => {
      if (entorus === null) {
        entorus = false;
      }

      Translit.three(text, entorus);
    };

    Restangular.all('/lms_page_templates/tags').getList().then((items) => {
      $scope.items = _.map(items, (item, index) => {
        return { text: item, id: index };
      });
    });

    $scope.loadTags = (query) => {
      return Restangular.all("/lms_page_templates/tags?q=" + query).getList();
    };

    $scope.webPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/lms_pages/" + $state.params.siteId),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });

    $scope.webPreviewUploader.onAfterAddingFile = (item) => {
      const ref = item.file.type;
      const types = ["image/jpeg", "image/png"];
      if (types.indexOf(ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };

    $scope.webPreviewUploader.onSuccessItem = (fileItem, response, status, headers) => {
      $scope.webPreviewUploader.clearQueue();
      $scope.new_site.preview = response.preview.preview;
    };

    $scope.webPreviewUploader.onErrorItem = (fileItem, response, status, headers) => {
      console.error({fileItem, response, status, headers});
    };


    $scope.mobilePreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/lms_pages/" + $state.params.siteId),
      autoUpload: false,
      method: "PUT",
      alias: "mobile_preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });

    $scope.mobilePreviewUploader.onAfterAddingFile = function(item) {
      const ref = item.file.type;
      const types = ["image/jpeg", "image/png"];
      if (types.indexOf(ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };

    $scope.mobilePreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.mobilePreviewUploader.clearQueue();
      $scope.new_site.mobile_preview = response.mobile_preview;
    };

    $scope.mobilePreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};


    const setUploadUrls = (siteId) => {
      $scope.mobilePreviewUploader.queue.forEach(function(item) {
        return item.url = Restangular.configuration.baseUrl + ("/lms_pages/" + siteId);
      });
      $scope.webPreviewUploader.queue.forEach((item) => {
        return item.url = Restangular.configuration.baseUrl + ("/lms_pages/" + siteId);
      });
    };

    $scope.cancel = () => {
      $modalInstance.dismiss("cancel");
    };

    $scope.close = () => {
      $modalInstance.dismiss("close");
    };

    $scope.creating = false;
    $scope.site.disabled = true;
    $scope.createTemplate = (lesson, newTemplateLesson) => {
      if (newTemplateLesson.$invalid) {
        return false;
      }
      $scope.creating = true;
      lesson.is_template = true;
      lesson.tags = _.map(lesson.tags, (tag) => {
        return tag.text;
      });
      lesson.tags = lesson.tags.join(",");
      lesson.description = 'Blank template by admin';
      lesson.colors = _.map(lesson.colors, (tag) => {
        return tag.text;
      });

      Lesson.create(lesson).then((new_site) => {
        $scope.new_site = new_site;
        $scope.creating = false;
        setUploadUrls($scope.new_site.id);
        $scope.mobilePreviewUploader.uploadAll()
        $scope.webPreviewUploader.uploadAll();
        $rootScope.$broadcast("lesson_form:created", $scope.new_site);
        $scope.close();
      }, (errors) => {
        $scope.errors = errors.data.errors;
        $scope.creating = false;
      });
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/lesson/newLesson.controller.js